module.exports = __webpack_public_path__ + "img/commerce_1.6ff17d44.jpg";